export function tokenGetter() {
  return localStorage.getItem('access_token');
}
